import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

export default function DynamicSelect({
  name,
  value,
  options,
  onChange,
  width = '70%',
  isDisabled = false
}) {
  return (
    <div style={{ width: width }}>
      <Select
        isClearable
        name={name}
        options={options}
        value={options.find(option => option.value === value) || null}
        onChange={selected => onChange(name, selected ? selected.value : '')}
        isDisabled={isDisabled}
      />
    </div>
  );
}

DynamicSelect.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  options: PropTypes.array,
  onChange: PropTypes.func,
  isDisabled: PropTypes.bool,
  width: PropTypes.string
};
